import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14.017 18l-2.017 2l-7.5 -7.428a5 5 0 0 1 .49 -7.586m3.01 -1a5 5 0 0 1 4 2.018a5 5 0 0 1 8.153 5.784","key":"svg-0"}],["path",{"d":"M11.814 11.814a2.81 2.81 0 0 0 -.007 3.948l4.182 4.238l2.01 -2.021m1.977 -1.99l.211 -.212a2.81 2.81 0 0 0 0 -3.948a2.747 2.747 0 0 0 -3.91 -.007l-.283 .178","key":"svg-1"}],["path",{"d":"M3 3l18 18","key":"svg-2"}]]

const IconHeartsOff = createReactComponent('outline', 'hearts-off', 'HeartsOff', __iconNode);

export default IconHeartsOff;